import { Accordion } from "@au-schein-de/au-ui-library";
import type { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";
import { ProductDetailsNoTerpenesInfo } from "~/features/products/product-details-no-terpenes-info.component";
import { ProductDetailsTitle } from "./product-details-title.component";

interface ProductDetailsCardProps extends PropsWithChildren {
	title: string;
	info?: string;
	secondaryCharacteristic: string[];
	hasData: boolean;
}

export function ProductDetailsItem({
	title,
	info,
	secondaryCharacteristic,
	children,
	hasData,
}: ProductDetailsCardProps) {
	const { t } = useTranslation();

	return (
		<>
			<Accordion.Trigger>
				<ProductDetailsTitle title={title} info={info ?? title} />
			</Accordion.Trigger>

			<Accordion.Content>
				{hasData ? (
					<>
						{children}
						{secondaryCharacteristic?.length > 0 && (
							<div className="text-body-sm text-gray-500">
								{t("also")}: {secondaryCharacteristic.join(", ")}
							</div>
						)}
					</>
				) : (
					<ProductDetailsNoTerpenesInfo />
				)}
			</Accordion.Content>
		</>
	);
}
